<template>
  <div v-if="showHint">
    <div class="tipBlock">
      <span>{{ commissionContext }}</span>
      <el-popover
        popper-class="pop_content"
        v-if="cryptoChannel.includes(withdrawalType)"
        class="popover"
        placement="bottom-end"
        trigger="hover"
      >
        <svg-icon slot="reference" iconName="info-circle-icon" className="tooltip-icon" />
        <div>{{ $t('withdraw.otherMethod.amountsExceeding') }}</div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import { apiPaymentGetInfo } from '@/resource';

export default {
  name: 'FeeTip',
  props: {
    withdrawalType: Number,
    currency: String,
    withdrawalAmount: Number,
    mt4Account: Number
  },
  data() {
    return {
      commissionContext: '',
      showHint: false,
      percentageFee: 0,
      calculatedAmount: 0,
      cryptoChannel: [34, 36, 80, 81, 86, 87]
    };
  },
  watch: {
    withdrawalType(newWithdrawalType) {
      if (!newWithdrawalType) this.showHint = false;
      else this.getApiPaymentGetInfo(newWithdrawalType, this.currency, this.withdrawalAmount, this.mt4Account);
    }
  },
  methods: {
    getApiPaymentGetInfo(type, currency, amount, account) {
      if (type && currency && amount && account) {
        apiPaymentGetInfo({
          withdrawType: type,
          currency: currency,
          withdrawalAmount: amount,
          mt4Account: account
        }).then(resp => {
          const commissions = {
            31: 'withdraw.default.SkrillChargeAlert',
            32: 'withdraw.default.NetellerChargeAlert'
          };
          const content = commissions[type] ? commissions[type] : 'withdraw.otherMethod.withdrawalFees';

          let percentageFee = resp.data.percentage_fee;
          let calculatedAmount = resp.data.calculated_amount;
          this.showHint = resp.data.show_hint;

          this.commissionContext = this.$t(content, {
            percentageFee,
            calculatedAmount,
            currency
          });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tipBlock {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
